import EVCourseIcon from './CourseIcon'

export default EVCourseIcon
